'use strict';

require('../../style/index.less');

require('../../layout/style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/col/style/index.js
 ** module id = 225
 ** module chunks = 0
 **/